import { ChangeDetectionStrategy, Component } from "@angular/core";
import {MetadataLabelComponent} from "./metadata-label.component";

@Component({
    selector: "metadata-header",
    templateUrl: "./metadata-header.tmpl.html",
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class MetadataHeaderComponent extends MetadataLabelComponent
{

}
